import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';

@Component({
    selector: 'div [parcella-giudiziale-riepilogo-form]',
  templateUrl: 'parcella-giudiziale-riepilogo-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ParcellaGiudizialeRiepilogoForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input() parcellaGiudiziale: ParcellaGiudiziale;

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }
}
